import type { PropsWithChildren } from "react";
import { useCallback, useState } from "react";

import { DuplicateModuleSettingsContext } from "./DuplicateModuleSettingsContext";

export const DuplicateModuleSettingsProvider = ({ children }: PropsWithChildren) => {
  const [title, setTitle] = useState("");

  const reset = useCallback(() => setTitle(""), []);

  return (
    <DuplicateModuleSettingsContext.Provider value={{ title, setTitle, reset }}>
      {children}
    </DuplicateModuleSettingsContext.Provider>
  );
};
